type Props = {
  condition: boolean,
  wrapper: (children: React.ReactNode) => JSX.Element,
  children: JSX.Element,
};

const ConditionalWrapper = ({
  condition,
  wrapper,
  children,
}: React.PropsWithChildren<Props>) =>
  condition ? wrapper(children) : children;

export default ConditionalWrapper;
